import { useTranslation } from "react-i18next";

import LegalLayout from "./LegalLayout.jsx";
import LegalSections from "./LegalSections.jsx";
import { PRIVACY_CONTENT } from "./content/privacy.js";

export default function Privacy() {
  const { i18n, t } = useTranslation();
  const lang = i18n.language && PRIVACY_CONTENT[i18n.language]
    ? i18n.language
    : (i18n.language?.split("-")[0] || "uk");
  const content = PRIVACY_CONTENT[lang] || PRIVACY_CONTENT.uk;

  return (
    <LegalLayout
      title={content.title}
      lastUpdated={t("legal.lastUpdated", { date: content.lastUpdated })}
    >
      <p>{content.intro}</p>
      <LegalSections sections={content.sections} />
    </LegalLayout>
  );
}
